import { createElement } from "react";
import { Trans } from "react-i18next";
import { useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { SavedView } from "../SavedViewsMenu.types.ts";
import { FilterPage } from "../../../pageView/PageView.types.ts";
import { Result } from "../../../api/result.ts";
import { put } from "../../../api/apiShared.ts";
import { useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";
import { buildSavedViewScopeQuery } from "../SavedViewsMenu.hooks.ts";

export interface ICustomerDefaultViewHook {
    view: SavedView;
    savedViewType: FilterPage;
    scopeId?: string;
    secondaryScopeId?: string;
    onClose: () => void;
    onSuccess: () => void;
}

export function useSetCustomerDefaultViewHook(props: ICustomerDefaultViewHook) {
    const snackbar = useDotLegalSnackbar();

    const setCustomerDefaultMutation = useDotLegalMutation(setAsCustomerDefault);

    const handleSetCustomerDefault = () => {
        setCustomerDefaultMutation.mutateAsync(
            { viewId: props.view.id, savedViewType: props.savedViewType, scopeId: props.scopeId, secondaryScopeId: props.secondaryScopeId },
            {
                onSuccess: (response: Result<string>) => {
                    snackbar.show(
                        createElement(Trans, {
                            i18nKey: "viewSetAsCustomerDefaultSuccess",
                            values: { name: props.view.name },
                        })
                    );
                    props.onClose();
                    props.onSuccess();
                },
            }
        );
    };

    return {
        handleSetCustomerDefault,
        inProgress: setCustomerDefaultMutation.isLoading,
    };

    async function setAsCustomerDefault(data: { viewId: string; savedViewType: FilterPage; scopeId?: string; secondaryScopeId?: string }) {
        const scopeQuery = buildSavedViewScopeQuery(data.scopeId, data.secondaryScopeId);
        return await put<string>(`/saved-views/${data.viewId}/set-customer-default?savedViewType=${data.savedViewType}${scopeQuery}`, {});
    }
}
